export function generateLivanceContactUrl(type: "phone" | "whatsapp"): string {
  const HELP_PHONE_NUMBER = "11 3230-4410";
  const HELP_WHATSAPP_MESSAGE = "Olá, preciso de ajuda!";
  
  return generateContactUrl(HELP_PHONE_NUMBER, type, {
    text: HELP_WHATSAPP_MESSAGE,
  });
}

export function generateContactUrl(
  data: string,
  type: "phone" | "email" | "whatsapp",
  options?: { text?: string },
): string {
  const whatsappUrl = new URL("https://api.whatsapp.com/send");

  whatsappUrl.searchParams.set("phone", cleanAndPrefixPhoneNumber(data));
  if (options?.text) {
    whatsappUrl.searchParams.set("text", options.text);
  }

  const contactsUrls = {
    phone: `tel:${data}`,
    email: `mailto:${data}`,
    whatsapp: whatsappUrl.toString(),
  };

  return contactsUrls[type];
}

function cleanAndPrefixPhoneNumber(phoneNumber: string): string {
  const cleanPhoneNumber = phoneNumber.replace(/[()\s-]/g, "");
  return `55${cleanPhoneNumber}`;
}
